/**
 * SearchMaskBottom component
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled search bottom mask.
 */
const SearchMaskBottom = styled.div`
  background: linear-gradient(180deg, rgba(15, 15, 15, 0) 0%, #0f0f0f 50.54%);
  height: ${76.748 * Screen.widthRatio}px;
  width: ${748 * Screen.widthRatio}px;
  position: absolute;
  top: ${341 * Screen.widthRatio}px;
  left: ${1173 * Screen.widthRatio}px;
`;

export default SearchMaskBottom;
